module.exports = __webpack_public_path__ + "static/media/H2O_Molecule.8d749c98.png";